import { render } from "./EdadTextField.vue?vue&type=template&id=54c91df2&scoped=true"
import script from "./EdadTextField.vue?vue&type=script&lang=js"
export * from "./EdadTextField.vue?vue&type=script&lang=js"

import "./EdadTextField.vue?vue&type=style&index=0&id=54c91df2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c91df2"]])

export default __exports__